import { Box, Flex, HStack, IconButton, Menu, Portal, Text } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { SERVER } from 'api/config/url'
import { useState } from 'react'
import { MdSettings } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import { ROLES, ROLES_LABEL } from 'shared/constants/user'
import { authStore } from 'shared/store/auth'
import { getKeycloakConfig } from 'shared/utils/keycloak'
import { useColorMode } from 'uikit/ColorMode/ColorMode'
import { PrivateBox } from '../../features/Private/Private'
import {
  EkengSettings,
  ErrorOpenApiSettings,
  LunaSettings,
  MailingProviders,
  PaymentsIntervalSettings,
  Registry,
  SmsProviders,
} from './elements'

const { realm, clientId } = getKeycloakConfig()

export const ProfileWidget = ({ ...props }) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState(null)

  const history = useHistory()
  const { colorMode, toggleColorMode } = useColorMode()
  const { user } = useStore(authStore)

  const handleLogout = () => {
    history.push('/logout')
  }

  const getRolesString = () => {
    return user?.roles?.map((item) => `${ROLES_LABEL[item] || item}`) || []
  }

  return (
    <Flex alignItems="center" {...props}>
      <Box mr={4} lineHeight="1.5" flex={1}>
        <Text fontSize="0.88rem" textAlign="right" fontWeight="semibold">
          {user?.login}
        </Text>
        <HStack gap={1} maxW="300px" flexWrap="wrap" justifyContent="flex-end">
          {getRolesString().map((item) => (
            <Text key={item} fontSize="0.7rem" textAlign="right" color="gray.400">
              {item}
            </Text>
          ))}
        </HStack>
      </Box>
      <Menu.Root onSelect={(e) => setSelectedMenuItem(e.value)}>
        <Menu.Trigger asChild>
          <IconButton
            rounded="full"
            size="sm"
            width="40px"
            height="40px"
            minWidth="36px"
            fontSize="1rem"
            variant="outline"
            color="gray.500"
          >
            <MdSettings />
          </IconButton>
        </Menu.Trigger>
        <Portal>
          <Menu.Positioner>
            <Menu.Content
              minWidth="240px"
              boxShadow="rgba(15, 15, 15, 0.05) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.1) 0px 9px 24px"
              p={0}
              py={1}
            >
              <PrivateBox hasAnyRole={[ROLES.admin]}>
                <Menu.Item
                  value="payments-interval"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('payments-interval')}
                >
                  Интервал между переводами
                </Menu.Item>
                <Menu.Item
                  value="luna-settings"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('luna-settings')}
                >
                  Ручная идентификация
                </Menu.Item>
                <Menu.Item
                  value="ekeng-settings"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('ekeng-settings')}
                >
                  Режим ЕКЕНГ
                </Menu.Item>
                <Menu.Item
                  value="error-open-api-settings"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('error-open-api-settings')}
                >
                  Настройка ошибок OpenApi
                </Menu.Item>
                <Menu.Item
                  value="sms-providers"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('sms-providers')}
                >
                  SMS провайдеры
                </Menu.Item>
                <Menu.Item
                  value="registry"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('registry')}
                >
                  Отправка реестров
                </Menu.Item>
                <Menu.Item
                  value="mailing-providers"
                  cursor="pointer"
                  onClick={() => setSelectedMenuItem('mailing-providers')}
                >
                  Оператор рассылки email
                </Menu.Item>
              </PrivateBox>
              <Menu.Separator />
              <Menu.Item value="theme" cursor="pointer" onClick={toggleColorMode}>
                {colorMode === 'dark' ? 'Светлая тема' : 'Темная тема'}
              </Menu.Item>
              <Menu.Separator />

              <Menu.Item
                onClick={() => {
                  const postLogoutRedirectUri = encodeURIComponent(window.location.origin)
                  const keycloakLogoutUrl = `${SERVER}/keycloak/auth/realms/${realm}/protocol/openid-connect/logout`
                  const fullLogoutRd = `${keycloakLogoutUrl}?post_logout_redirect_uri=${postLogoutRedirectUri}&client_id=${clientId}`
                  const fullLogoutUrl = `/oauth2/sign_out?rd=${encodeURIComponent(fullLogoutRd)}`

                  window.location.href = fullLogoutUrl
                }}
                cursor="pointer"
                style={{ textDecoration: 'none' }}
              >
                Выход
              </Menu.Item>
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
      </Menu.Root>

      <PaymentsIntervalSettings
        isOpen={selectedMenuItem === 'payments-interval'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <LunaSettings
        isOpen={selectedMenuItem === 'luna-settings'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <EkengSettings
        isOpen={selectedMenuItem === 'ekeng-settings'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <ErrorOpenApiSettings
        isOpen={selectedMenuItem === 'error-open-api-settings'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <SmsProviders
        isOpen={selectedMenuItem === 'sms-providers'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <Registry
        isOpen={selectedMenuItem === 'registry'}
        onClose={() => setSelectedMenuItem(null)}
      />
      <MailingProviders
        isOpen={selectedMenuItem === 'mailing-providers'}
        onClose={() => setSelectedMenuItem(null)}
      />
    </Flex>
  )
}
